<h2 i18n="@@mergeCustomer.heading.compareCustomerData">Compare customer data</h2>

<div class="esf-info-tile-grid esf-info-tile-grid--3" style="justify-content: center">
  <div class="esf-info-tile-grid">
    <h3 i18n="@@mergeCustomer.heading.firstCustomer">First customer</h3>

    <app-merge-customer-data [id]="'firstCustomerData'"
                             [customer]="firstCustomerData"
                             [type]="tablesTranslations.i18nCustomerData"
                             [selectedClub]="selectedClub"
                             [viewOnly]="true">
    </app-merge-customer-data>
  </div>

  <div class="esf-info-tile-grid">
    <h3 i18n="@@mergeCustomer.heading.secondCustomer">Second customer</h3>

    <app-merge-customer-data [id]="'secondCustomerData'"
                             [customer]="secondCustomerData"
                             [type]="tablesTranslations.i18nCustomerData"
                             [selectedClub]="selectedClub"
                             [viewOnly]="true">
    </app-merge-customer-data>
  </div>

</div>

<div class="esf-info-tile-grid esf-info-tile-grid--3" style="justify-content: center">
  <div class="esf-info-tile-grid">
    <app-merge-customer-data [id]="'firstCustomerCommunication'"
                             [customer]="firstCustomerData"
                             [type]="tablesTranslations.i18nComunicationData"
                             [selectedClub]="selectedClub"
                             [viewOnly]="true">
    </app-merge-customer-data>
  </div>

  <div class="esf-info-tile-grid">
    <app-merge-customer-data [id]="'secondCustomerCommunication'"
                             [customer]="secondCustomerData"
                             [type]="tablesTranslations.i18nComunicationData"
                             [selectedClub]="selectedClub"
                             [viewOnly]="true">
    </app-merge-customer-data>
  </div>

</div>

<div class="esf-info-tile-grid esf-info-tile-grid--3" style="justify-content: center">
  <div class="esf-info-tile-grid">
    <app-merge-customer-data [id]="'firstCustomerAttributes'"
                             [customer]="firstCustomerData"
                             [type]="tablesTranslations.i18nAttribute"
                             [selectedClub]="selectedClub"
                             [viewOnly]="true">
    </app-merge-customer-data>
  </div>

  <div class="esf-info-tile-grid">
    <app-merge-customer-data [id]="'secondCustomerAttributes'"
                             [customer]="secondCustomerData"
                             [type]="tablesTranslations.i18nAttribute"
                             [selectedClub]="selectedClub"
                             [viewOnly]="true">
    </app-merge-customer-data>
  </div>

</div>

<div class="esf-info-tile-grid esf-info-tile-grid--3" style="justify-content: center" *ngIf="selectedClub.isCrmMembershipActive">
  <div class="esf-info-tile-grid">
    <app-merge-customer-data [id]="'firstCustomerMembership'"
                             [customer]="firstCustomerData"
                             [type]="tablesTranslations.i18nMembership"
                             [countries]="countries"
                             [selectedClub]="selectedClub"
                             [viewOnly]="true">
    </app-merge-customer-data>
  </div>

  <div class="esf-info-tile-grid">
    <app-merge-customer-data [id]="'secondCustomerMembership'"
                             [customer]="secondCustomerData"
                             [type]="tablesTranslations.i18nMembership"
                             [countries]="countries"
                             [selectedClub]="selectedClub"
                             [viewOnly]="true">
    </app-merge-customer-data>
  </div>
</div>

<div class="esf-info-tile-grid esf-info-tile-grid--3" style="justify-content: center" *ngIf="selectedClub.isCampaiMembershipActive">
  <div class="esf-info-tile-grid">
    <app-merge-customer-data [id]="'firstCustomerMembership'"
                             [customer]="firstCustomerData"
                             [type]="tablesTranslations.i18nMembershipCampai"
                             [countries]="countries"
                             [selectedClub]="selectedClub"
                             [viewOnly]="true">
    </app-merge-customer-data>
  </div>

  <div class="esf-info-tile-grid">
    <app-merge-customer-data [id]="'secondCustomerMembership'"
                             [customer]="secondCustomerData"
                             [type]="tablesTranslations.i18nMembershipCampai"
                             [countries]="countries"
                             [selectedClub]="selectedClub"
                             [viewOnly]="true">
    </app-merge-customer-data>
  </div>
</div>

<div class="esf-info-tile-grid esf-info-tile-grid--3" style="justify-content: center">
  <div class="esf-info-tile-grid">
    <app-merge-customer-data [id]="'firstCustomerStandardAddress'"
                             [customer]="firstCustomerData"
                             [type]="tablesTranslations.i18nStandardAddress"
                             [countries]="countries"
                             [selectedClub]="selectedClub"
                             [viewOnly]="true">
    </app-merge-customer-data>
  </div>

  <div class="esf-info-tile-grid">
    <app-merge-customer-data [id]="'secondCustomerStandardAddress'"
                             [customer]="secondCustomerData"
                             [type]="tablesTranslations.i18nStandardAddress"
                             [countries]="countries"
                             [selectedClub]="selectedClub"
                             [viewOnly]="true">
    </app-merge-customer-data>
  </div>

</div>

<div class="esf-info-tile-grid esf-info-tile-grid--3" style="justify-content: center">
  <div class="esf-info-tile-grid">
    <app-merge-customer-data [id]="'firstCustomerInvoices'"
                             [customer]="firstCustomerData"
                             [type]="tablesTranslations.i18nInvoices"
                             [selectedClub]="selectedClub"
                             [viewOnly]="true">
    </app-merge-customer-data>
  </div>

  <div class="esf-info-tile-grid">
    <app-merge-customer-data [id]="'secondCustomerInvoices'"
                             [customer]="secondCustomerData"
                             [type]="tablesTranslations.i18nInvoices"
                             [selectedClub]="selectedClub"
                             [viewOnly]="true">
    </app-merge-customer-data>
  </div>
</div>

<ng-container *ngIf="selectedClub.isMerchandisingActive">

  <div class="esf-info-tile-grid esf-info-tile-grid--3" style="justify-content: center">
    <div class="esf-info-tile-grid">
      <app-merge-customer-data [id]="'firstCustomerInvoices'"
                               [customer]="firstCustomerData"
                               [type]="tablesTranslations.i18nMerchandising"
                               [selectedClub]="selectedClub"
                               [viewOnly]="true">
      </app-merge-customer-data>
    </div>

    <div class="esf-info-tile-grid">
      <app-merge-customer-data [id]="'secondCustomerInvoices'"
                               [customer]="secondCustomerData"
                               [type]="tablesTranslations.i18nMerchandising"
                               [selectedClub]="selectedClub"
                               [viewOnly]="true">
      </app-merge-customer-data>
    </div>

  </div>

</ng-container>
